/**
 * @file Route: collectionoverview
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { Header } from "components/Header/Info";
import zacc from "@olmokit/core/zacc/withCheckbox";
import { $, $all, forEach, on, getDataAttr } from "@olmokit/dom";
import StickySidebar from "@olmokit/core/scroll/stickySidebar";
import { breakpoints } from "@olmokit/core/scss";

import { render } from "@olmokit/utils/render";
import { post } from "@olmokit/core/fragments/ajax";

import {
  dataLayerFilter,
  dataLayerSelectItem
} from "components/Datalayer"

import { ecommerceTackClick } from "components/Datalayer";

import "@olmokit/core/forms/checkbox";
import "@olmokit/core/progress/loading.scss";
import "components/Cover";
import "components/Collections";
import "components/Card/Collection";
import "./index.scss";

console.log("Route collectionoverview/index.js mounted.");

Header();

const $filters = $(".filters:");

const sidebar = new StickySidebar("#sticky-sidebar", {
    containerSelector: "#sticky-main",
    innerWrapperSelector: "#sticky-inner",
    minWidth: breakpoints.sm
  });

/**
 * ----------------------
 * FILTERS
 * ----------------------
 */

/**
 * Component: Filters
 */
function trackCardClick() {

  ecommerceTackClick()

  const $cards = $all('a.CardCollection:link');
  forEach($cards, (card) => {
    on(card, 'click', (e) => {
      // e.preventDefault();
      const $trackData = card.getAttribute('data-track-collection-link')
      const data = JSON.parse($trackData)
      console.log(data.name, data.name, data.variant, data.position);
      dataLayerSelectItem(data.name, data.name, data.variant, data.position)
    })
  })
}

/**
 * Setup the property store
 * */
let property = {};

FiltersToLoadingPage("filters");
PropertyOption("filters");


const renderCardProduct = render($("#card-product").innerHTML);

/**
 * This function manage the click on the property value
 * if the class is-filter is in the filter means the filter is active
 * so remove the class by clicking viceversa add it
 */
export function PropertyOption(urlrequest) {

  const filters = $all('.Filters:property_value');

  forEach(filters, (el) => {
    on(el, 'click', (e) => {

      e.preventDefault();
      const filter = $('.Filters:property_value-checkbox .formControl', el);
      const id = filter.getAttribute('data-id');
      const value = filter.getAttribute('value');
      const namevalue = filter.getAttribute('namevalue');
      const nameproperty = filter.getAttribute('nameproperty');

      if(!el.classList.contains('is-filter')){

        el.classList.add('is-filter');

        /** Push value in the store and set params */
        storeProperty('add', id, value);
        setParams('add', id, property[id]);
        dataLayerFilter(nameproperty, namevalue, 'add')

      } else {

        el.classList.remove('is-filter');

        /** Push value in the store and set params */
        storeProperty('remove', id, value);
        setParams('remove', id, property[id]);
        dataLayerFilter(nameproperty, namevalue, 'remove')

      }

      productRefresh(property, urlrequest);

    });
  });

  // mobile accordion to toggle all filter, it must be initialised after its
  // nested accordions for a correct behaviour
  let mobileAccordion;

  // accordions
  forEach($all(".filter:"), $filter => {
    zacc($filter, {
      duration: 300,
      opened: () => {
        mobileAccordion ? mobileAccordion.recalculate() : null;
        sidebar.updateSticky("resize");
      },
      closed: () => {
        mobileAccordion ? mobileAccordion.recalculate() : null;
        sidebar.updateSticky("resize");
      }
    });
  });

  mobileAccordion = zacc($filters, { duration: 300 });

}

/**
 * This function manage the filters activation by loading the page
 * if the params are in the url
 */
export function FiltersToLoadingPage(urlrequest) {

  let url = window.location.href;
  let urlUrl = new URL(url);
  let params = new URLSearchParams(urlUrl.search.slice(1));

  const filters = $all('.Filters:property_value');

  let array;
  let valuesObj = [];
  let val = {};

  for (let p of params) {

    if(parseInt(p[0]) && parseInt(p[1])){
      val[p[0]] = p[1];
      let rawArray = JSON.parse("[" + p[1] + "]");
      val[p[0]] = rawArray;
      array = rawArray;

      property = val;

      forEach(filters, (el) => {
        const filter = $('.Filters:property_value-checkbox .formControl', el);
        const id = filter.getAttribute('data-id');
        const value = filter.getAttribute('value');

        if (array.includes(parseInt(value))) {
          el.classList.add('is-filter');

          if (!valuesObj[id]) {
            valuesObj[id] = [value];
          } else {
            valuesObj[id].push(value);
          }
        }
      });
    } else {
      params.delete(p[0]);
      window.history.replaceState({}, "", `${location.pathname}?${params}`);
    }

  }

  if(valuesObj.length > 0){
    productRefresh(valuesObj, urlrequest);
  }

}

export function storeProperty(type, id, value) {
  if(type == 'add'){
    if(property[id]){
      property[id].push(value);
    } else {
      property[id] = [value];
    }
  } else if(type == 'remove') {
    const size = Object.keys(property).length;
    if(size == 1 && property[id].length == 0){
      property = [];
    } else {
      const arr = property[id].filter((e) => e != value);
      property[id] = arr;
      if(property[id].length == 0) {
        delete property[id];
      }
    }
  }
}

export function setParams(type, name, value) {
  let url = window.location.href;
  let urlUrl = new URL(url);
  let params = new URLSearchParams(urlUrl.search.slice(1));

  const size = Object.keys(property).length;

  if(type == 'add'){
    /** Just add a param */
    params.set(name, value);
    window.history.replaceState({}, "", `${location.pathname}?${params}`);
  } else {
    /** Check if there is no value */
    if(size == 0){
      window.history.replaceState({}, "", `${location.pathname}`);
    } else {
      /** 
       * Check if the value is true means the property still has value 
       * otherwise delete the property
       * */
      if(value){
        params.set(name, value);
      } else {
        params.delete(name);
      }
      window.history.replaceState({}, "", `${location.pathname}?${params}`);
    }
  }
}


export function productRefresh(data, urlrequest) {

  let queryValues = [];

  for (const [key, value] of Object.entries(data)) {
    queryValues.push(JSON.parse("[" + value + "]"));
  }

  const $products = $(".Products:results");
  // const pasteNumber = $('.Filters:title_num-val');
  const loader = $('.results:loader');

  loader.style.display = 'flex';

  post('filters', {
    data: {
      id: JSON.stringify(queryValues),
    },
  }).then(({ data }) => {
    // $products.innerHTML = data;
    $products.innerHTML = renderCardProduct({
      results: data.elements
    });

    sidebar.updateSticky("resize");

    trackCardClick()

    // new LazyLoad();

    // const $noResult = $(".Collections:empty");
    // if(data.counter == 0){
    //   $noResult.style.display = "block";
    // } else {
    //   $noResult.style.display = "none";
    // }
    // pasteNumber.innerHTML = $productsList.getAttribute('data-number');
    // pasteNumber.innerHTML = data.elements.length;

    loader.style.display = 'none';

    // MinOpen();
    // CardProduct();
    // CardProductProps();

    // disableProperty();
  });
}